import { NavLink } from 'react-router-dom';
import { NAV_ITEMS, ADMIN_NAV_ITEM } from '../config/nav';
import { useAuth } from '../contexts/AuthContext';

export function BottomNav() {
  const { user, status } = useAuth();
  const items = status === 'guest'
    ? NAV_ITEMS.filter(i => i.to === '/spots')
    : (user?.isSuperAdmin ? [...NAV_ITEMS, ADMIN_NAV_ITEM] : NAV_ITEMS);
  return (
    <nav
      className="fixed bottom-0 inset-x-0 md:hidden flex border-t border-slate-200 dark:border-slate-800 bg-white/85 dark:bg-slate-900/85 backdrop-blur z-30"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {items.map(i => (
        <NavLink
          key={i.to}
          to={i.to}
          className={({ isActive }) =>
            `relative flex-1 flex flex-col items-center justify-center gap-0.5 min-h-[60px] py-2 text-[11px] font-medium transition-colors ${
              isActive
                ? 'text-teal-600 dark:text-teal-400'
                : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <span
                aria-hidden="true"
                className={`absolute top-0 left-3 right-3 h-0.5 rounded-full transition-opacity ${
                  isActive ? 'bg-teal-600 dark:bg-teal-400 opacity-100' : 'opacity-0'
                }`}
              />
              {i.icon}
              <span>{i.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
